var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['spacer', _vm.advanced.cssClasses, _vm.addedClass, _vm.responsiveClasses],style:(_vm.outerStyle),attrs:{"id":_vm.advanced.cssId}},[_c('label',{staticClass:"sp-label",style:(_vm.labelStyle)},[_vm._v(" "+_vm._s(_vm.basic.label || 'Label')+" ")]),_c('div',{staticClass:"inner-spacer",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }